import React, {useReducer } from 'react'


import reducer from './Reducer'
import Context from './Context'
import {initState} from './Reducer'


// const initState = {'language' : 'vie'}

const Provider = ({children}) =>{
   
    const [state,dispatch] = useReducer(reducer,initState);

    return (
        <Context.Provider value={[state,dispatch]}>
            {children}
        </Context.Provider>
    )

}


export default Provider;